import React from 'react';
import TrackerPage from '../components/TrackerPage';
import { CARD, VIEWS } from '../utils/trackerConstants';

const CARDS = [CARD.total, CARD.awaitingTutor, CARD.newTutorAssigned, CARD.pending, CARD.retained, CARD.tutorChange];

// CRO: replacements on their own students with the TA wing's current status, read-only.
export default function CroReplacements() {
  return <TrackerPage view={VIEWS.CRO} title={'Tutor Replacement Status'} cards={CARDS} />;
}
